module.exports = "#content-wrapper h2{\n    font-family: 'blogger_sansbold';\n    font-size: 18px;\n    text-transform: uppercase;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/t-and-c/t-and-c.component.css
// module id = ./src/app/t-and-c/t-and-c.component.css
// module chunks = main